import * as React from "react";
import { JSX } from "react/jsx-runtime";
const AccordianPlusIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 9.18164H9.1813H17.3626"
      stroke="#004E9B"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.18164 1L9.18164 9.1813L9.18164 17.3626"
      stroke="#004E9B"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default AccordianPlusIcon;
